import {call, takeEvery, put } from 'redux-saga/effects';
import * as type from '../../types';
import {createSubscriptionApi, viewSubscriptionApi, updateSubscriptionApi} from '../../api/admin/SubscriptionApis'



function* handleCreateSubscription(action) {
    try {
        // Call the API function with the payload
        const response = yield call(createSubscriptionApi, action.payload);
        // Dispatch the success action with the response
        yield put({ type: type.SUBSCRIPTION_CREATE_SUCCESS, response });
    } catch (error) {
        // Dispatch the failure action with the error message
        yield put({ type: type.SUBSCRIPTION_CREATE_FAILURE, error: error.message });
    }
}

function* handleViewSubscription() {
    try {
      const response = yield call(viewSubscriptionApi);
      // Assuming response.data contains the subscriptionmasters array
      const subscriptions = response.data?.subscriptionmasters || [];
      yield put({ type: type.SUBSCRIPTIONS_FETCH_SUCCESS, subscriptions });
    } catch (error) {
      yield put({ type: type.SUBSCRIPTIONS_FETCH_FAILURE, error: error.message });
    }
  }

  function* handleUpdateSubscription(action) {
    try {
        // Call the API with the ID and payload
        const response = yield call(updateSubscriptionApi, action.id, action.payload);
        // Dispatch success action with API response
        yield put({ type: type.SUBSCRIPTION_UPDATE_SUCCESS, response });
    } catch (error) {
        // Dispatch failure action with error message
        yield put({ type: type.SUBSCRIPTION_UPDATE_FAILURE, error: error.message });
    }
}



// Watcher saga
export function* watchFetchCreateSubscriptSaga() {
    yield takeEvery(type.SUBSCRIPTION_CREATE_REQUEST, handleCreateSubscription)
}
export function* watchViewSubscriptSaga() {
    yield takeEvery(type.SUBSCRIPTIONS_FETCH_REQUEST, handleViewSubscription)
}
export function* watchUpdateSubscriptSaga(){
  yield takeEvery(type.SUBSCRIPTION_UPDATE_REQUEST, handleUpdateSubscription)
}